export const selectEmployeeRoles = (state) =>
  state.companyEmployeeRoles?.employees || [];
export const selectEmployeeRolesLoading = (state) =>
  state.companyEmployeeRoles?.loading || false;
export const selectAvailableRoles = (state) =>
  state.companyEmployeeRoles?.roles || [];
export const selectAvailableRolesLoading = (state) =>
  state.companyEmployeeRoles?.rolesLoading || false;
export const selectAssigningRole = (state) =>
  state.companyEmployeeRoles?.assigningRole || false;
